<template>
    <div class="container ">
        <div class="breadcrumbs-retos py-3">
            <a href="/home-bat">
                <img src="/img/icons/homeBread.svg" alt="" />
            </a>
            <span class="color-active-miga link"><strong>Mi Perfil</strong></span>
        </div>
        <div class="header-catalog mb-2">
            <h5>Mi Perfil</h5>
        </div>

        <div class="row header-profile align-items-start">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                <el-card class="box-card">
                    <div class="row d-flex align-items-center">
                        <div
                            class="col-3 col-sm-3 col-md-3 col-lg-2 col-xl-2 d-flex justify-content-start align-items-center">
                            <img src="/img-version2/icons/User_global.svg" alt="" class="user-icon-profile">
                        </div>
                        <div class="col-9 col-sm-9 col-md-9 col-lg-10 col-xl-10 name-h6-global ps-1">
                            <h6 class="mb-0 text-truncate">{{ user.name }}</h6>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12">
                            <div class=" points-to-expire-global rounded-3 px-3 py-2 " v-if="[1,2,3,4,6,7,9,10,22,8,19,20,21,23].includes(segmentation_id) && userPoints !== null">
                                <p class="text-title-bat text-strong-global">
                                    <!--                                <h6>Puntos a vencer: {{ next_to_expire.total }}</h6>-->
                                    <h6>Puntos a vencer: {{ userPoints }}</h6>
                                </p>
<!--                                <p class="text-bat mt-2">Fecha: {{ formatDate(next_to_expire.fecha) }}</p>-->
                                <p class="text-bat mt-2">Fecha: 31/10/2026</p>
                            </div>
                        </div>
                        <div class="col-12 mt-4">
                            <a class="w-100 btn text-title-bat rounded-3 btn-season" href="/cambiar-password">
                                <span>Cambiar contraseña</span>
                            </a>
                        </div>
                    </div>

                </el-card>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 profile-container-two">
                <div class="row">
                    <div class="col-12">
                        <button @click="handlerDeliveryData()" style="width: 100%; padding: 16px !important;"
                                class="text-dark rounded-3 bg-white shadow p-2 px-3 border-0 text-title-bat d-flex align-items-center">
                            <img class="me-2" src="/img-version2/icons/edit_delivery.svg"
                                 alt="Actualizar datos de redención">
                            Actualización datos de redención
                            <span class="chevron-team-icon ms-auto">
                                <svg width="12" height="20" viewBox="0 0 12 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 2L10 10L2 18" stroke="#464646" stroke-width="2" stroke-linecap="round"
                                          stroke-linejoin="round" />
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div v-if="[1, 2, 3, 4, 6, 7, 8, 9, 10, 19, 20, 21, 22, 23].includes(segmentation_id)"
                         class="col-12 mt-4">
                        <el-card class="text-bat">
                            <h6>Mis sucursales</h6>
                            <el-collapse v-model="activeBranch">
                                <el-collapse-item v-for="(pdv, index) in pdvs" :key="index" :name="'pdv-' + pdv.id">
                                    <template #title>
                                        <div class="pdv-title-profile">
                                            <div class="pdv-name-profile">
                                                {{ truncateText(formatName(pdv.name_pdv), 35) }}
                                            </div>
                                            <div class="pdv-address-profile">
                                                <img src="/img-version2/icons/staff/location.svg" alt="location" />
                                                {{ truncateText(pdv.address_pdv, 35) }}
                                            </div>
                                        </div>
                                    </template>
                                    <p class="mb-0"> ● {{ pdv.insitu_code }}</p>
                                    <el-divider />
                                    <div v-if="pdv.representative && pdv.representative.length > 0">
                                        <div v-for="(salesRep, index) in pdv.representative" :key="index">
                                            <p class="mb-0"><strong>{{ formatName(salesRep.sales_rep_name) }}</strong>
                                            </p>
                                            <p class="mb-0">( +57 ) {{ salesRep.sales_rep_phone }}</p>
                                            <p class="mb-0">Día de visita: <strong>{{ salesRep.visit_days }}</strong>
                                            </p>
                                            <el-divider v-if="index < pdv.representative.length - 1" />
                                        </div>
                                    </div>
                                    <div v-else>
                                        <p class="mb-0">No hay representantes de ventas asignados.</p>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </el-card>
                    </div>
                </div>
            </div>
        </div>

        <div class="row delivery-data mt-4">
            <div class="col-12 mb-4">
                <button v-if="view_delivery_data === true" @click="handlerDeliveryData()"
                        class="text-secondary text-title-bat border-0 bg-transparent border-bottom border-3 border-secondary">
                    < Regresar</button>
            </div>
        </div>

        <div v-if="view_delivery_data == false" class="row content-profile mt-2" id="my-redemptions">
            <div class="col-sm-12 col-md-6">
                <div class="tabs">
                    <ul class="nav nav-pills mb-3">
                        <li class="nav-item" role="presentation">
                            <button @click="change_tab('history_points')"
                                    :class="current_tab === 'history_points' ? 'active' : ''" class="nav-link" type="button"
                                    role="tab" aria-controls="pills-home"
                                    :aria-selected="current_tab === 'history_points' ? true : false">Mis Avances</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button @click="change_tab('my_redemptions')"
                                    :class="current_tab === 'my_redemptions' ? 'active' : ''" class="nav-link" type="button"
                                    role="tab" aria-controls="pills-profile"
                                    :aria-selected="current_tab === 'my_redemptions' ? true : false">Mis Canjes</button>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-sm-12 col-md-6" v-if="current_tab === 'history_points'">
                <div class="filter-month">
                    <form>
                        <select v-model="selected_month_points" id="select-month" name="Meses"
                                @change="getHistoryPoints(1)">
                            <option value="all">Todos</option>
                            <option v-for="month in points_months" :value="month.value">{{ month.key }}</option>
                        </select>
                    </form>
                </div>
            </div>
            <div class="col-sm-12 col-md-6" v-if="current_tab === 'my_redemptions'">
                <div class="filter-month">
                    <form>
                        <select v-model="month_filter_my_redemptions" id="select-month" name="Meses"
                                @change="filterMyRedemptionsMonths()">
                            <option value="all">Todos</option>
                            <option v-for="(month, index) in pastMonths" :key="index" :value="month.id">{{ month.name }}
                            </option>
                        </select>
                    </form>
                </div>
            </div>

            <div v-if="current_tab === 'history_points'">
                <div v-if="history_points !== null">
                    <div v-if="history_points && history_points.data.length !== 0">
                        <div class="row justify-content-center p-3 py-5">
                            <div v-for="transaction in history_points.data" :key="transaction.id"
                                 class="col-lg-4 col-md-5 col-12 card-points my-3 my-sm-1">
                                <div class="header">
                                    <div>
                                        <span
                                            :class="['badge', transaction.transaction_status_id === 1 ? 'tag-despachado' : transaction.transaction_status_id === 2 ? 'tag-entregado' : 'tag-rechazado']">Estado</span>
                                        <span
                                            :class="['traffic-light', transaction.transaction_status_id === 1 ? 'tag-despachado' : transaction.transaction_status_id === 2 ? 'tag-entregado' : 'tag-rechazado']"></span>
                                        {{ transaction.transaction_status.name }}
                                        <img v-if="transaction.transaction_status_id === 3"
                                             :src="'/../img-version2/icons/info-circle.svg'">
                                    </div>
                                    <div class="box-points">
                                        <span><strong>{{ [1, 3].includes(transaction.transaction_type_id) ? '+' : '-' }}
                                                {{ transaction.amount }} <span> Puntos</span></strong></span>
                                    </div>
                                </div>
                                <div class="content">
                                    <div class="row">
                                        <div class="col-12">
                                            <h6>{{ transaction.transaction_detail }}</h6>
                                        </div>
                                    </div>
                                    <div v-if="[1, 3, 4].includes(transaction.transaction_type_id)" class="row">
                                        <div class="col-12 available-points">
                                            <h6>Puntos disponibles: {{ transaction.available_points }}</h6>
                                        </div>
                                    </div>
                                    <div class="row date-history-points">
                                        <div class="col-6">
                                            <p><strong>Fecha:</strong></p>
                                            <p><span>{{ formatDate(transaction.created_at) }}</span></p>
                                        </div>
                                        <div v-if="transaction.savings_expiration_date !== null" class="col-6 pb-1">
                                            <p><strong>Vence:</strong></p>
                                            <p><span>{{ formatDate(transaction.savings_expiration_date) }}</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="container-fluid py-5 no-found">
                            <img src="/img-version2/brand/no-found.png" alt="no found">
                            <span>Aún no tienes un historial de puntos para ver</span>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="d-flex align-items-center justify-content-center">
                            <button @click="previousPage" class="bg-transparent border-0"
                                    :disabled="pageSelected === 1">
                                &lt;
                            </button>
                            <div class="text-bat">
                                <span v-if="visiblePagesProgress[0] > 1">...</span>
                                <span v-for="page in visiblePagesProgress" :key="page"
                                      @click="goToPageGetHistoryPoints(page)" class="mx-3 mx-md-4 cursor-pointer"
                                      :class="{ 'text-title-bat text-orange': page === pageSelected }">{{ page }}</span>
                                <span
                                    v-if="visiblePagesProgress[visiblePagesProgress.length - 1] < pagesTotals">...</span>
                            </div>
                            <button @click="nextPageGetHistoryPoints" class="bg-transparent border-0"
                                    :disabled="pageSelected === pagesTotals || pagesTotals === 0"> &gt; </button>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="row ">
                        <div class="col-12 d-flex justify-content-center align-items-center bg-light">
                            <div class="card text-center shadow-sm border-0 mt-2" style="width: 10rem;">
                                <div class="card-body">

                                    <!-- Spinner -->
                                    <div class="spinner-border text-primary mb-2" role="status"
                                         style="width: 2rem; height: 2rem;">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>

                                    <!-- Texto -->
                                    <p class="mb-0 mt-2 text-muted">Cargando datos</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br><br>
                </div>
            </div>

            <div v-if="current_tab === 'my_redemptions'">
                <div v-if="all_redemptions_raw !== null">
                    <div v-if="filteredByMonth && filteredByMonth.length !== 0">
                        <div class="row justify-content-center p-3 py-5">
                            <div class="col-lg-4 col-md-6 col-12 card-reden my-3 my-sm-1 px-2"
                                 v-for="(redemption, index) in paginatedRedemptions" :key="index">
                                <div class="header">
                                    <div>
                                        <span :class="{
                                            'badge': true,
                                            'tag-rechazado': redemption.StatusId === 12,
                                            'tag-entregado': redemption.StatusId === 2 || redemption.StatusId === 11 || redemption.StatusId === 10,
                                            'tag-despachado': redemption.StatusId !== 12 && redemption.StatusId !== 2 && redemption.StatusId !== 11 && redemption.StatusId !== 10
                                        }">Estado</span>
                                        <span :class="{
                                            'traffic-light': true,
                                            'tag-rechazado': redemption.StatusId === 12,
                                            'tag-entregado': redemption.StatusId === 2 || redemption.StatusId === 11 || redemption.StatusId === 10,
                                            'tag-despachado': redemption.StatusId !== 12 && redemption.StatusId !== 2 && redemption.StatusId !== 11 && redemption.StatusId !== 10
                                        }"></span> {{ redemption.StatusName }}
                                        <img v-if="redemption.StatusId === 12"
                                             :src="'/../img-version2/icons/info-circle.svg'">
                                    </div>
                                    <div class="box-points">
                                        <span><strong>{{ (redemption.PointsUnitValue) +
                                        (redemption.PointsUnitShippingValue ? redemption.PointsUnitShippingValue
                                            :
                                            0) }}
                                                <span> Puntos</span></strong></span>
                                    </div>
                                </div>
                                <div class="content">
                                    <div class="row img-name-redeem">
                                        <div class="img-reden col-5">
                                            <img v-if="redemption.ProductImage"
                                                 :src="(my_redemptions ? my_redemptions.domain : '') + redemption.ProductImage.replace('~/', '')"
                                                 :alt="redemption.ProductName" width="100%">
                                            <img v-else :src="(my_redemptions ? my_redemptions.domain : '') + redemption.ProductImage"
                                                 :alt="redemption.ProductName">
                                        </div>
                                        <div class="name-redeem col-7">
                                            <h6 class="name-h6">{{ redemption.ProductName }}</h6>
                                        </div>
                                    </div>
                                    <!-- Condiciones para mostrar contenido -->
                                    <div>
                                        <div v-if="redemption.ProductTypeId === 1">
                                            <div
                                                v-if="redemption.ProductTypeId === 1 && redemption.LinkPdfRedemption && redemption.CodigoDigital">
                                                <p class="m-0"><strong>Disfruta de tu redención:</strong></p>
                                                <div v-if="shouldShowDetails(redemption.StatusId)">
                                                    <p class="m-0 code text-bat">Dirígete al <strong>“Ver más”</strong>
                                                        para
                                                        descargar tu bono</p>
                                                </div>
                                                <div v-else>
                                                    <p class="m-0 code text-bat">*****</p>
                                                </div>
                                                <p class="custom-p m-0 m-0 pt-3 pb-3"><strong class="pe-2">Número de
                                                    orden:</strong><span class="code-profile text-bat"> {{
                                                        redemption.OrderGuid }} </span></p>
                                            </div>
                                            <div v-else-if="!redemption.LinkPdfRedemption && redemption.CodigoDigital">
                                                <div>
                                                    <p class="m-0"><strong>Disfruta de tu redención:</strong></p>
                                                    <div v-if="shouldShowDetails(redemption.StatusId)">
                                                        <p class="m-0 code text-bat">{{ redemption.CodigoDigital }}</p>
                                                    </div>
                                                    <div v-else>
                                                        <p class="m-0 code text-bat">*****</p>
                                                    </div>
                                                    <p class="custom-p m-0 m-0 pt-3 pb-3"><strong class="pe-2">Número de
                                                        orden:</strong><span class="code-profile text-bat"> {{
                                                            redemption.OrderGuid }} </span></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else-if="redemption.ProductTypeId === 8">
                                            <p class="m-0"><strong>Disfruta de tu redención:</strong></p>
                                            <div v-if="shouldShowDetails(redemption.StatusId)">
                                                <p class="m-0 code text-bat">Dirígete al <strong>“Ver más”</strong> para
                                                    conocer
                                                    las
                                                    instrucciones de redención de tu bono</p>
                                            </div>
                                            <div v-else>
                                                <p class="m-0 code text-bat">*****</p>
                                            </div>
                                            <p class="custom-p m-0 m-0 pt-3 pb-3"><strong class="pe-2">Número de
                                                orden:</strong><span class="code-profile text-bat">
                                                    {{ redemption.OrderGuid }} </span></p>
                                        </div>
                                        <div v-else-if="redemption.ProductTypeId === 2">
                                            <p class="m-0"><strong>Disfruta de tu redención:</strong></p>
                                            <div v-if="shouldShowDetails(redemption.StatusId)">
                                                <p class="m-0 code text-bat">Dirígete al <strong>“Ver más”</strong> para
                                                    conocer
                                                    las
                                                    instrucciones de redención de tu producto</p>
                                            </div>
                                            <div v-else>
                                                <p class="m-0 code text-bat">*****</p>
                                            </div>
                                            <p class="custom-p m-0 m-0 pt-3 pb-3"><strong class="pe-2">Número de
                                                orden:</strong><span class="code-profile text-bat">{{
                                                    redemption.OrderGuid }}</span></p>
                                        </div>
                                        <div v-else-if="redemption.ProductTypeId === 3">
                                            <p class="m-0"><strong>Disfruta de tu redención:</strong></p>
                                            <div v-if="shouldShowDetails(redemption.StatusId)">
                                                <p class="m-0 code text-bat">Dirígete al <strong>“Ver más”</strong> para
                                                    conocer
                                                    las
                                                    instrucciones de redención de tu recarga</p>
                                            </div>
                                            <div v-else>
                                                <p class="m-0 code text-bat">*****</p>
                                            </div>

                                            <p class="custom-p m-0 pt-3 pb-3"><strong class="pe-2">Número de
                                                orden:</strong><span class="code-profile text-bat">{{
                                                    redemption.OrderGuid }}</span></p>
                                        </div>
                                        <div v-else-if="redemption.ProductTypeId === 5">
                                            <p class="m-0"><strong>Disfruta de tu redención:</strong></p>
                                            <div v-if="shouldShowDetails(redemption.StatusId)">
                                                <p class="m-0 code text-bat">Dirígete al <strong>“Ver más”</strong> para
                                                    conocer
                                                    las
                                                    instrucciones de redención de tu bono</p>
                                            </div>
                                            <div v-else>
                                                <p class="m-0 code text-bat">*****</p>
                                            </div>
                                            <p class="custom-p m-0 pt-3 pb-3"><strong class="pe-2">Número de
                                                orden:</strong><span class="code-profile text-bat">{{
                                                    redemption.OrderGuid }}</span></p>
                                        </div>
                                        <div v-else-if="redemption.ProductTypeId === 6">
                                            <p class="m-0"><strong>Disfruta de tu redención:</strong></p>
                                            <div v-if="shouldShowDetails(redemption.StatusId)">
                                                <p class="m-0 code text-bat">Dirígete al <strong>“Ver más”</strong> para
                                                    conocer
                                                    las
                                                    instrucciones de redención de tu bono</p>
                                            </div>
                                            <div v-else>
                                                <p class="m-0 code text-bat">*****</p>
                                            </div>
                                            <p class="custom-p m-0 pt-3 pb-3"><strong class="pe-2">Número de
                                                orden:</strong><span class="code-profile text-bat">{{
                                                    redemption.OrderGuid }}</span></p>
                                        </div>
                                        <div v-else-if="redemption.ProductTypeId === 7">
                                            <div>
                                                <p class="m-0"><strong>Disfruta de tu redención:</strong></p>
                                                <div v-if="shouldShowDetails(redemption.StatusId)">
                                                    <p class="m-0 code text-bat">Dirígete al <strong>“Ver más”</strong>
                                                        para
                                                        descargar tu
                                                        bono</p>
                                                </div>
                                                <div v-else>
                                                    <p class="m-0 code text-bat">*****</p>
                                                </div>
                                                <p class="custom-p m-0 pt-3 pb-3"><strong class="pe-2">Número de
                                                    orden:</strong><span class="code-profile text-bat">{{
                                                        redemption.OrderGuid }}</span></p>
                                            </div>
                                        </div>
                                        <div v-else-if="redemption.ProductTypeId === 9">
                                            <div>
                                                <p class="m-0"><strong>Disfruta de tu redención:</strong></p>
                                                <div v-if="shouldShowDetails(redemption.StatusId)">
                                                    <p class="m-0 code text-bat">Dirígete al <strong>“Ver más”</strong>
                                                        para
                                                        conocer las
                                                        instrucciones de redención de tu bono</p>
                                                </div>
                                                <div v-else>
                                                    <p class="m-0 code text-bat">*****</p>
                                                </div>

                                                <p class="custom-p m-0 pt-3 pb-3"><strong class="pe-2">Número de
                                                    orden:</strong><span class="code-profile text-bat">{{
                                                        redemption.OrderGuid }}</span></p>
                                            </div>
                                        </div>
                                        <div v-else-if="redemption.ProductTypeId === 10">
                                            <div>
                                                <p class="m-0"><strong>Disfruta de tu redención:</strong></p>
                                                <div v-if="shouldShowDetails(redemption.StatusId)">
                                                    <p class="m-0 code text-bat">{{ redemption.CodigoDigital }}</p>
                                                </div>
                                                <div v-else>
                                                    <p class="m-0 code text-bat">*****</p>
                                                </div>
                                                <p class="custom-p m-0 pt-3 pb-3"><strong class="pe-2">Número de
                                                    orden:</strong><span class="code-profile text-bat">{{
                                                        redemption.OrderGuid }}</span></p>
                                            </div>
                                        </div>
                                        <div v-else-if="redemption.ProductTypeId === 11">
                                            <div>
                                                <p class="m-0"><strong>Disfruta de tu redención:</strong></p>
                                                <div v-if="shouldShowDetails(redemption.StatusId)">
                                                    <p class="m-0 code text-bat">Dirígete al <strong>“Ver
                                                        más”</strong>conocer
                                                        las instrucciones de redención de tu recarga
                                                        bono</p>
                                                </div>
                                                <div v-else>
                                                    <p class="m-0 code text-bat">*****</p>
                                                </div>
                                                <p class="custom-p m-0 pt-3 pb-3"><strong class="pe-2">Número de
                                                    orden:</strong><span class="code-profile text-bat">{{
                                                        redemption.OrderGuid }}</span></p>
                                            </div>
                                        </div>
                                        <div v-else-if="redemption.ProductTypeId === 12">
                                            <div>
                                                <p class="m-0"><strong>Disfruta de tu redención:</strong></p>
                                                <div v-if="shouldShowDetails(redemption.StatusId)">
                                                    <p class="m-0 code text-bat">Dirígete al <strong>“Ver más”</strong>
                                                        para
                                                        conocer las instrucciones de redención de tu producto</p>
                                                </div>
                                                <div v-else>
                                                    <p class="m-0 code text-bat">*****</p>
                                                </div>

                                                <p class="custom-p m-0 pt-3 pb-3"><strong class="pe-2">Número de
                                                    orden:</strong><span class="code-profile text-bat">{{
                                                        redemption.OrderGuid }}</span></p>
                                            </div>
                                        </div>
                                        <div v-else-if="redemption.ProductTypeId === 13">
                                            <div>
                                                <p class="m-0"><strong>Disfruta de tu redención:</strong></p>
                                                <div v-if="shouldShowDetails(redemption.StatusId)">
                                                    <p class="m-0 code text-bat">Dirígete al <strong>“Ver más”</strong>
                                                        para
                                                        conocer las instrucciones de redención de tu producto</p>
                                                </div>
                                                <div v-else>
                                                    <p class="m-0 code text-bat">*****</p>
                                                </div>

                                                <p class="custom-p m-0 pt-3 pb-3"><strong class="pe-2">Número de
                                                    orden:</strong><span class="code-profile text-bat">{{
                                                        redemption.OrderGuid }}</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row date-redeem">
                                        <div class="col-6">
                                            <p><strong>Fecha de canje:</strong></p>
                                            <p><span>{{ formatDate(redemption.OrderDate) }}</span></p>
                                        </div>
                                        <div class="col-6 pb-1">
                                            <p><strong>Fecha de entrega:</strong></p>
                                            <p><span>{{ formatDate(redemption.ExpectedDelivery) }}</span></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end text-decoration-underline">
                                    <span v-if="shouldShowVerMas(redemption.StatusId)"
                                          class="text-more cursor-pointer text-decoration-underline"
                                          @click="showRedemptionDetail(redemption)">Ver más</span>
                                </div>
                            </div>
                            <div v-if="showModalRedemption">
                                <redemptions-popups :redemption_details="redemption_details"
                                                    :history_points="history_points" :my_redemptions="my_redemptions"
                                                    :user_data="user_data" :closeRedemptionDetailModal="closeRedemptionDetailModal"
                                                    :segmentation_id="segmentation_id"></redemptions-popups>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="container-fluid py-5 no-found">
                            <img src="/img-version2/brand/no-found.png" alt="no found">
                            <span>Aún no tienes un historial de canjes para ver en este periodo</span>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="d-flex align-items-center justify-content-center">
                            <button @click="prevPage" class="bg-transparent border-0" :disabled="pageSelected === 1">
                                &lt;
                            </button>
                            <div class="text-bat">
                                <div v-if="visiblePages.length > 0">
                                    <span v-if="visiblePages[0] > 1">...</span>
                                    <span v-for="page in visiblePages" :key="page" @click="goToPage(page)"
                                          class="mx-3 mx-md-4 cursor-pointer"
                                          :class="{ 'text-title-bat text-orange': page === pageSelected }">
                                        {{ page }}
                                    </span>
                                    <span v-if="visiblePages[visiblePages.length - 1] < pagesTotals">...</span>
                                </div>
                            </div>
                            <button @click="nextPage" class="bg-transparent border-0" :disabled="pageSelected === pagesTotals || pagesTotals === 0">
                                &gt;
                            </button>
                        </div>
                        <div>
                            <div v-if="loadingData" class="text-center">
                                <p class="text-bat">Cargando...</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div v-else>
                    <div class="row ">
                        <div class="col-12 d-flex justify-content-center align-items-center bg-light">
                            <div class="card text-center shadow-sm border-0 mt-2" style="width: 10rem;">
                                <div class="card-body">

                                    <!-- Spinner -->
                                    <div class="spinner-border text-primary mb-2" role="status"
                                         style="width: 2rem; height: 2rem;">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>

                                    <!-- Texto -->
                                    <p class="mb-0 mt-2 text-muted">Cargando datos</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br><br>
                </div>
            </div>

        </div>

        <div v-else>
            <div class="col-12 col-md-12 col-lg-6">
                <div v-if="personal_data && personal_data.length > 0" class="row mb-4">
                    <div class="col-md-6 mb-3">
                        <a @click="addDeliveryData" class="wrapper-add-delivery mb-3 shadow p-2"
                           :class="personal_data.length >= 3 ? 'disabled-add' : ''">
                            <!-- <p><i class="fa fa-plus" aria-hidden="true"></i></p> -->
                            <p>
                                Agregar información de entrega
                                <i class="ms-2 fa fa-plus" aria-hidden="true"></i>
                            </p>
                        </a>
                    </div>
                    <div v-for="(item, index) in personal_data" class="col-md-6">
                        <div class="wrapper-delivery mb-3 position-relative shadow "
                             :class="item.is_default_option == 1 ? 'active' : 'inactive'">
                            <div v-if="item.is_default_option == 1" class="car-container">
                                <img src="/img-version2/icons/delivery-1.svg" alt="delivery">
                            </div>
                            <div @click="changeDeliveryData(item.id)" class="box box1">
                                <div class="start">
                                    <img v-if="item.is_default_option == 1" src="/img-version2/icons/arrow-right.svg"
                                         alt="arrow-right">
                                    <img v-if="item.is_default_option == 0"
                                         src="/img-version2/icons/arrow-right-secondary.svg" alt="arrow-right-secondary">
                                </div>
                                <div class="preliminary-information">
                                    <p class="address text-truncate w-100">{{ item.address }}</p>
                                    <p class="email text-truncate w-100">{{ item.email }}</p>
                                    <p class="mobile-number">{{ formatMobileNumber(item.mobile_number) }}</p>
                                </div>
                            </div>
                            <div class="box box2">
                                <a class="edit-delivery-data" @click="editDeliveryData(item, index)"><img
                                    src="/img-version2/icons/edit-2.svg" alt="edit-2"></a>

                                <a v-if="personal_data && personal_data.length > 1 && personal_data_default && item.id == personal_data_default.id"
                                   class="default-delivery-data"><img src="/img-version2/icons/tick-circle.svg"
                                                                      alt="trash"></a>
                                <a v-else class="delete-delivery-data" @click="deleteDeliveryData(item, index)"><img
                                    src="/img-version2/icons/trash.svg" alt="trash"></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="row mb-4">
                    <div class="col-12 col-md-6">
                        <a @click="addDeliveryData" class="wrapper-add-delivery mb-3 shadow p-2">
                            <!-- <p><i class="fa fa-plus" aria-hidden="true"></i></p> -->
                            <p>
                                Agregar información de entrega
                                <i class="ms-2 fa fa-plus" aria-hidden="true"></i>
                            </p>
                        </a>
                    </div>
                </div>


                <div ref="addDataForm">
                    <div v-if="add_delivery_data && !edit_delivery_data && personal_data && personal_data.length < 3"
                         class="form-cart mb-3">
                        <div>
                            <h5 class="mt-3 mb-1">
                                Detalles del cliente
                            </h5>
                            <div class="data-description mb-3">
                                <p class="data-label fs-6 mb-0">Nombre</p>
                                <p v-if="user_data && user_data.name" class="data-value fs-6 fw-bolder">{{
                                        user_data.name }}</p>
                                <p v-else class="data-value fs-6 fw-bolder">No aplica</p>
                            </div>
                            <div class="data-description mb-3">
                                <p class="data-label fs-6 mb-0">Número de documento</p>
                                <p v-if="user_data && user_data.identification_number"
                                   class="data-value fs-6 fw-bolder">{{
                                        user_data.identification_number }}</p>
                                <p v-else class="data-value fs-6 fw-bolder">No aplica</p>
                            </div>
                        </div>
                        <div>
                            <h5 class="mt-3 mb-1">
                                Para agregar una nueva dirección
                            </h5>
                            <div class="data-description mb-3">
                                <p class="data-label fs-6 mb-0">Confirma los siguientes datos</p>
                            </div>
                        </div>
                        <form @submit.prevent="storeDeliveryData" class="d-flex flex-column">

                            <input v-model="state_id" name="state_id_nc" type="hidden" />
                            <input v-model="state_name" name="state_name_nc" type="hidden" />
                            <input v-model="city_id" name="city_id_nc" type="hidden" />
                            <input v-model="city_name" name="city_name_nc" type="hidden" />

                            <div class="row my-3">
                                <div class="col-12 d-flex flex-column">
                                    <label for="email" style="width:10%;" id="label-1">E-mail</label>
                                    <input v-model="email" type="text" name="email">
                                    <span v-if="errors_personal_data && errors_personal_data.email"
                                          class="error text-danger" for="image">{{ errors_personal_data.email[0] }}</span>
                                </div>
                            </div>
                            <div class="row my-3">
                                <div class="col-12 d-flex flex-column">
                                    <label for="" style="width:17%" id="label-3">Departamento</label>
                                    <select v-model="state">
                                        <option v-for="state in states" :value="state">{{ state.name }}</option>
                                    </select>
                                    <span v-if="errors_personal_data && errors_personal_data.state_id_nc"
                                          class="error text-danger" for="image">{{ errors_personal_data.state_id_nc[0]
                                        }}</span>
                                </div>
                            </div>
                            <div class="row my-3">
                                <div class="col-12 d-flex flex-column">
                                    <label for="" style="width:10%" id="label-4">Ciudad</label>
                                    <select v-model="city">
                                        <option v-for="city in cities" :value="city">{{ city.name_city }}</option>
                                    </select>
                                    <span v-if="errors_personal_data && errors_personal_data.city_id_nc"
                                          class="error text-danger" for="image">{{ errors_personal_data.city_id_nc[0]
                                        }}</span>
                                </div>
                            </div>
                            <div class="row my-3">
                                <div class="col-12 d-flex flex-column">
                                    <label for="" style="width:14%" id="label-5">Dirección</label>
                                    <input v-model="address" type="text" name="">
                                    <span v-if="errors_personal_data && errors_personal_data.address"
                                          class="error text-danger" for="image">{{ errors_personal_data.address[0]
                                        }}</span>
                                </div>
                            </div>
                            <div class="row my-3">
                                <div class="col-12 d-flex flex-column">
                                    <label for="mobile_number" style="width:10%" id="label-2">Celular</label>
                                    <input v-model="mobile_number" type="text" name="mobile_number">
                                    <span v-if="errors_personal_data && errors_personal_data.mobile_number"
                                          class="error text-danger" for="image">{{ errors_personal_data.mobile_number[0]
                                        }}</span>
                                </div>
                            </div>
                            <div class="row my-3">
                                <div class="col-12 d-flex flex-column">
                                    <label for="additional_info" style="width:30%" id="label-8">Instrucciones de
                                        entrega</label>
                                    <input type="text" v-model="delivery_instructions" name="additional_info"
                                           placeholder="apartamento, torre, piso, etc...">
                                    <span v-if="errors_personal_data && errors_personal_data.delivery_instructions"
                                          class="error text-danger" for="image">{{
                                            errors_personal_data.delivery_instructions[0] }}</span>
                                </div>
                            </div>
                            <div v-if="personal_data && personal_data.length > 0"
                                 class="check-form-cart d-flex align-items-start">
                                <input v-model="is_default_option" type="checkbox" name="is_default_option">
                                <span class="ps-1">Establecer información de entrega como predeterminada.</span>
                            </div>

                            <div class="row mt-3">
                                <div class="col-12 next-button">
                                    <button class="btnBlue" style="width: 100%;">Guardar</button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div v-else-if="add_delivery_data && edit_delivery_data && selected_delivery_data !== null"
                         class="form-cart mb-3">
                        <form @submit.prevent="updateDeliveryData" class="d-flex flex-column">
                            <input v-model="personal_data_to_edit.id" name="id" type="hidden" />
                            <input v-model="state_id" name="state_id_nc" type="hidden" />
                            <input v-model="state_name" name="state_name_nc" type="hidden" />
                            <input v-model="city_id" name="city_id_nc" type="hidden" />
                            <input v-model="city_name" name="city_name_nc" type="hidden" />

                            <div class="row my-3">
                                <div class="col-12 d-flex flex-column">
                                    <label for="email" style="width:10%;" id="label-1">E-mail</label>
                                    <input v-model="email" type="text" name="email">
                                    <span v-if="errors_personal_data && errors_personal_data.email"
                                          class="error text-danger" for="image">{{ errors_personal_data.email[0] }}</span>
                                </div>
                            </div>
                            <div class="row my-3">
                                <div class="col-12 d-flex flex-column">
                                    <label for="" style="width:17%" id="label-3">Departamento</label>
                                    <select v-model="state">
                                        <option v-for="state in states" :value="state">{{ state.name }}</option>
                                    </select>
                                    <span v-if="errors_personal_data && errors_personal_data.state_id_nc"
                                          class="error text-danger" for="image">{{ errors_personal_data.state_id_nc[0]
                                        }}</span>
                                </div>
                            </div>
                            <div class="row my-3">
                                <div class="col-12 d-flex flex-column">
                                    <label for="" style="width:10%" id="label-4">Ciudad</label>
                                    <select v-model="city">
                                        <option v-for="city in cities" :value="city">{{ city.name_city }}</option>
                                    </select>
                                    <span v-if="errors_personal_data && errors_personal_data.city_id_nc"
                                          class="error text-danger" for="image">{{ errors_personal_data.city_id_nc[0]
                                        }}</span>
                                </div>
                            </div>
                            <div class="row my-3">
                                <div class="col-12 d-flex flex-column">
                                    <label for="" style="width:14%" id="label-5">Dirección</label>
                                    <input v-model="address" type="text" name="">
                                    <span v-if="errors_personal_data && errors_personal_data.address"
                                          class="error text-danger" for="image">{{ errors_personal_data.address[0]
                                        }}</span>
                                </div>
                            </div>
                            <div class="row my-3">
                                <div class="col-12 d-flex flex-column">
                                    <label for="mobile_number" style="width:10%" id="label-2">Celular</label>
                                    <input v-model="mobile_number" type="text" name="mobile_number">
                                    <span v-if="errors_personal_data && errors_personal_data.mobile_number"
                                          class="error text-danger" for="image">{{ errors_personal_data.mobile_number[0]
                                        }}</span>
                                </div>
                            </div>
                            <div class="row my-3">
                                <div class="col-12 d-flex flex-column">
                                    <label for="additional_info" style="width:30%" id="label-8">Instrucciones de
                                        entrega</label>
                                    <input type="text" v-model="delivery_instructions" name="additional_info"
                                           placeholder="apartamento, torre, piso, etc...">
                                    <span v-if="errors_personal_data && errors_personal_data.delivery_instructions"
                                          class="error text-danger" for="image">{{
                                            errors_personal_data.delivery_instructions[0] }}</span>
                                </div>
                            </div>
                            <div class="check-form-cart d-flex align-items-start">
                                <input v-if="is_default_option == true && personal_data_to_edit.is_default_option == 1"
                                       v-model="is_default_option" type="checkbox" name="is_default_option" disabled>
                                <input v-else v-model="is_default_option" type="checkbox" name="is_default_option">
                                <span class="ps-1">Establecer información de entrega como predeterminada.</span>
                            </div>
                            <div class="row mt-3">
                                <div class="col-12 next-button">
                                    <button class="btnBlue" style="width: 100%;">Actualizar</button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div v-else-if="add_delivery_data && !edit_delivery_data && personal_data && personal_data.length == 3"
                         class="msj-error mt-4">
                        <div class="content d-flex align-items-start p-2">
                            <p class="mb-0" style="font-size: 14px;"> Alcanzaste el tope de perfiles de envío. Puedes
                                usar los que ya creaste o actualizarlos dando clic en "Editar".</p>
                        </div>
                    </div>

                    <div v-else-if="!add_delivery_data && !edit_delivery_data && personal_data && personal_data.length > 0"
                         class="selected-delivery-data">
                        <div v-if="successfully_created_message && !successfully_updated_message && !successfully_deleted_message"
                             class="msj-success mt-4">
                            <div class="content d-flex align-items-start p-2">
                                <p class="mb-0" style="font-size: 14px;"> Información de entrega <strong>creada</strong>
                                    exitosamente!.</p>
                            </div>
                        </div>
                        <div v-if="!successfully_created_message && successfully_updated_message && !successfully_deleted_message"
                             class="msj-success mt-4">
                            <div class="content d-flex align-items-start p-2">
                                <p class="mb-0" style="font-size: 14px;"> Información de entrega
                                    <strong>actualizada</strong> exitosamente!.
                                </p>
                            </div>
                        </div>
                        <div v-if="!successfully_created_message && !successfully_updated_message && successfully_deleted_message"
                             class="msj-success mt-4">
                            <div class="content d-flex align-items-start p-2">
                                <p class="mb-0" style="font-size: 14px;"> Información de entrega
                                    <strong>eliminada</strong> exitosamente!.
                                </p>
                            </div>
                        </div>
                        <div class="header my-3">
                            <h6 class="title">Información de Entrega</h6>
                            <p class="subtitle">Confirma los siguientes datos.</p>
                        </div>
                        <div class="data-description mb-3">
                            <p class="data-label">Nombre</p>
                            <p v-if="user_data && user_data.name" class="data-value">{{ user_data.name }}</p>
                            <p v-else class="data-value">No aplica</p>
                        </div>
                        <div class="data-description mb-3">
                            <p class="data-label">Número de documento</p>
                            <p v-if="user_data && user_data.identification_number" class="data-value">{{
                                    user_data.identification_number }}</p>
                            <p v-else class="data-value">No aplica</p>
                        </div>
                        <div class="data-description mb-3">
                            <p class="data-label">Dirección</p>
                            <p v-if="selected_delivery_data" class="data-value">{{ selected_delivery_data.address }}, {{
                                    selected_delivery_data.city_name_nc }} ({{ selected_delivery_data.state_name_nc }})</p>
                            <p v-else class="data-value">No aplica</p>
                        </div>
                        <div class="data-description mb-3">
                            <p class="data-label">Email</p>
                            <p v-if="selected_delivery_data" class="data-value">{{ selected_delivery_data.email }}</p>
                            <p v-else class="data-value">No aplica</p>
                        </div>
                        <div class="data-description mb-3">
                            <p class="data-label">Celular</p>
                            <p v-if="selected_delivery_data" class="data-value">{{
                                    formatMobileNumber(selected_delivery_data.mobile_number) }}</p>
                            <p v-else class="data-value">No aplica</p>
                        </div>
                        <div class="data-description mb-3">
                            <p class="data-label">Instrucciones de entrega</p>
                            <p v-if="selected_delivery_data" class="data-value">
                                {{ (selected_delivery_data.delivery_instructions != null &&
                                selected_delivery_data.delivery_instructions != '') ?
                                selected_delivery_data.delivery_instructions : 'No aplica' }}
                            </p>
                            <p v-else class="data-value">No aplica</p>
                        </div>
                        <div>
                            <p class="text-danger d-flex align-items-center fs-6">
                                <img class="me-2" src="/img-version2/icons/red-semaforo.svg" alt="">
                                Esta es la información de entrega, favor verificar.
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import RedemptionsPopups from "../RedemptionsPopups/RedemptionsPopups.vue";
import {EventBus} from "../../app";

export default {
    components: { RedemptionsPopups },
    props: {
        client_id: {
            default: null,
        },
        user: {
            default: null,
        },
        pdvs: {
            default: null,
        },
        segmentation_id: {
            default: 0,
        }
    },
    data() {
        return {
            showModalRedemption: false,
            show_redemption_details: false,
            redemption_details: null,
            loading: 0,
            current_tab: 'history_points',
            history_points: null,
            tier_segments: [1, 2, 3, 4],
            change_password_roles: [12, 5, 13],
            points_months: null,
            next_to_expire: null,
            selected_month_points: 'all',
            month_filter_my_redemptions: 'all',
            sales_representative: null,
            advanceWorkingDays: 0,
            currentMonth: null,
            customColorWorkDays: '#12C2E9',

            states: null,
            cities: null,

            name: '',
            label_personal_data: '',
            email: '',
            mobile_operator: '',
            mobile_number: '',
            state: null,
            state_id: '',
            state_name: '',
            city: null,
            city_id: '',
            city_name: '',
            address: '',
            delivery_instructions: '',
            is_default_option: false,

            view_delivery_data: false,
            errors_personal_data: [],
            personal_data: [],
            personal_data_default: null,
            user_data: null,

            add_delivery_data: false,
            edit_delivery_data: false,
            selected_delivery_data: null,
            personal_data_to_edit: null,

            successfully_created_message: false,
            successfully_updated_message: false,
            successfully_deleted_message: false,
            months: [
                { id: 1, name: 'Enero' },
                { id: 2, name: 'Febrero' },
                { id: 3, name: 'Marzo' },
                { id: 4, name: 'Abril' },
                { id: 5, name: 'Mayo' },
                { id: 6, name: 'Junio' },
                { id: 7, name: 'Julio' },
                { id: 8, name: 'Agosto' },
                { id: 9, name: 'Septiembre' },
                { id: 10, name: 'Octubre' },
                { id: 11, name: 'Noviembre' },
                { id: 12, name: 'Diciembre' }
            ],
            pastMonths: 0,
            last_page: null,
            pageSelected: 1,
            pagesTotals: null,
            visiblePagesProgress: [1, 2],
            visiblePages: [],
            currentPage: 1,
            showPaginationNot: false,
            loadingData: false,
            activeAccordion: null,
            activeBranch: [],
            norteVisits: [
                { name: "Pepito Mendieta Rodriguez", phone: "(+57) 320 432 74 63", day: "Miércoles" },
                { name: "Pepito Mendieta Rodriguez", phone: "(+57) 320 432 74 63", day: "Lunes" }
            ],

            all_redemptions_raw: null,
            my_redemptions: { data: [], domain: '' },
            itemsPerPage: 12,
            userPoints: null,
        }
    },
    computed: {
        // Filtro de redenciones basado en el select de meses
        filteredByMonth() {
            if (this.month_filter_my_redemptions === 'all') {
                return this.all_redemptions_raw;
            }
            return this.all_redemptions_raw.filter(item => {
                const orderDate = new Date(item.OrderDate);
                return (orderDate.getMonth() + 1) === this.month_filter_my_redemptions;
            });
        },

        // Corta el array filtrado para mostrar solo los de la página actual
        paginatedRedemptions() {
            const start = (this.pageSelected - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredByMonth.slice(start, end);
        },

        // Calcula el total de páginas basado en el filtro actual
        pagesTotals() {
            return Math.ceil(this.filteredByMonth.length / this.itemsPerPage) || 0;
        }
    },
    mounted() {
        this.getUserPoints()
        EventBus.$on('refresh-points', function (data) {
            this.getUserPoints()
        }.bind(this));
        this.updateUrl('my_redemptions');

        this.checkInitialTabUrl()

        this.getMyRedemptions()
        this.getHistoryPoints(1)

        if (this.tier_segments.includes(this.segmentation_id)) {
            this.getSalesRepresentative()
        }

        this.getStates()
        this.personal_data = this.getRedemptionPersonalData(this.client_id)
        this.setCurrentMonth();
    },
    watch: {
        state: function () {
            if (this.state) {
                this.state_id = this.state.id_departments
                this.state_name = this.state.name

                this.city = null
                this.getCities()
                if (this.edit_delivery_data) {
                    this.city = {
                        id_city: this.personal_data_to_edit.city_id_nc,
                        id_departments: this.personal_data_to_edit.state_id_nc,
                        name_city: this.personal_data_to_edit.city_name_nc
                    }
                }
            } else {
                this.state_id = ''
                this.state_name = ''
            }
        },
        city: function () {
            if (this.city) {
                this.city_id = this.city.id_city
                this.city_name = this.city.name_city
            } else {
                this.city_id = ''
                this.city_name = ''
            }
        },
        personal_data: function () {
            if (this.personal_data && this.personal_data.length == 1 && this.personal_data[0].is_default_option == 0) {
                this.personal_data[0].is_default_option = 1
                this.selected_delivery_data = this.personal_data[0]
            }
            this.add_delivery_data = false
            this.edit_delivery_data = false
        },
        filteredByMonth: {
            handler() {
                if (this.current_tab === 'my_redemptions') {
                    // Recalculamos el total de páginas
                    this.pagesTotals = Math.ceil(this.filteredByMonth.length / this.itemsPerPage);
                    // Volvemos a la página 1 si el filtro cambia
                    this.pageSelected = 1;
                    // Actualizamos los números visibles
                    this.updateVisiblePages();
                }
            },
            deep: true
        },
        pageSelected() {
            if (this.current_tab === 'my_redemptions') {
                this.updateVisiblePages();
            } else if (this.current_tab === 'history_points') {
                this.updateVisiblePagesProgress();
            }
        },
    },
    methods: {
        change_tab(new_tab) {
            this.pageSelected = 1;
            this.current_tab = new_tab;

            history.pushState(null, null, `mi-perfil?${new_tab}`);

            if (this.current_tab === 'history_points') {
                if (this.history_points === null) {
                    this.getHistoryPoints(1);
                }
            } else if (this.current_tab === 'my_redemptions') {
                if (this.all_redemptions_raw === null) {
                    this.getMyRedemptions();
                } else {
                    this.updateVisiblePages();
                }
            }
        },

        checkInitialTabUrl() {
            const showMyRedemptions = window.location.search;
            if (showMyRedemptions.includes('?my_redemptions')) {
                this.change_tab('my_redemptions');
            } else {
                this.change_tab('history_points');
            }
        },
        updateUrl(tab) {
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('my_redemptions', tab === 'my_redemptions');
            const newUrl = window.location.pathname + '?' + urlParams.toString();
            window.history.pushState({ path: newUrl }, '', newUrl);
        },
        getHistoryPoints(page) {
            this.loading++
            axios.get(`/points?page=${page}&month=${this.selected_month_points}`)
                .then(({ data }) => {
                    this.history_points = data.transactions
                    this.points_months = data.history_months
                    this.next_to_expire = data.next_to_expire
                    this.pagesTotals = data.transactions.last_page
                    this.pageSelected = page
                    this.updateVisiblePagesProgress()
                    const scrollPoints = document.getElementById('my-redemptions');
                    if (scrollPoints) {
                        scrollPoints.scrollIntoView({ behavior: 'smooth' });
                    }
                    this.loading--;
                })
        },
        previousPage() {
            this.pageSelected--;
            this.getHistoryPoints(this.pageSelected);

        },
        nextPageGetHistoryPoints() {
            this.pageSelected++;
            this.getHistoryPoints(this.pageSelected);

        },
        goToPageGetHistoryPoints(page) {
            this.pageSelected = page;
            this.getHistoryPoints(this.pageSelected);
        },

        async getMyRedemptions() {
            this.loadingData = true;
            try {
                const { data } = await axios.get('/my-redemption');
                this.all_redemptions_raw = data.all_data;

                if (!this.my_redemptions) {
                    this.my_redemptions = { data: [], domain: '' };
                }
                this.my_redemptions.domain = data.domain;

            } catch (error) {
                console.error("Error cargando canjes:", error);
            } finally {
                this.loadingData = false;
            }
        },

        updateVisiblePages(currentPage) {
            const pagesPerBlock = 5;
            const totalPages = this.pagesTotals;
            const currentPageToShow = currentPage || this.pageSelected;

            let startPage, endPage;

            const currentBlock = Math.ceil(currentPageToShow / pagesPerBlock);

            startPage = (currentBlock - 1) * pagesPerBlock + 1;
            endPage = Math.min(startPage + pagesPerBlock - 1, totalPages);

            const visiblePages = [];

            if (startPage > 1) {
                visiblePages.push(1);
                if (startPage > 2) {
                    visiblePages.push('...');
                }
            }

            for (let i = startPage; i <= endPage; i++) {
                visiblePages.push(i);
            }

            if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                    visiblePages.push('...');
                }
                visiblePages.push(totalPages);
            }

            this.visiblePages = visiblePages;
        },
        updateVisiblePagesProgress() {
            const totalPages = this.pagesTotals;
            const currentPage = this.pageSelected;

            const maxVisiblePages = 5;

            let startPage = currentPage - Math.floor(maxVisiblePages / 2);
            startPage = Math.max(1, startPage);

            let endPage = startPage + maxVisiblePages - 1;
            endPage = Math.min(totalPages, endPage);

            const visiblePagesProgress = [];
            if (startPage > 1) {
                visiblePagesProgress.push(1);
                if (startPage > 2) {
                    visiblePagesProgress.push('...');
                }
            }

            for (let i = startPage; i <= endPage; i++) {
                visiblePagesProgress.push(i);
            }

            if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                    visiblePagesProgress.push('...');
                }
                visiblePagesProgress.push(totalPages);
            }

            this.visiblePagesProgress = visiblePagesProgress;
        },

        goToPage(page) {
            this.pageSelected = page;
            this.updateVisiblePages();
            document.getElementById('my-redemptions').scrollIntoView({ behavior: 'smooth' });
        },

        prevPage() {
            this.pageSelected--;
        },

        nextPage() {
            this.pageSelected++;
        },

        filterMyRedemptionsMonths() {
            this.pageSelected = 1;
            this.updateVisiblePages();
        },
        formatDate(date) {
            const newDate = new Date(date)
            return `${newDate.getDate()}/${newDate.getMonth() + 1 < 10 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1}/${newDate.getFullYear()}`
        },
        getSalesRepresentative() {
            this.loading++
            axios.get(`/sales-representative`)
                .then(({ data }) => {
                    this.sales_representative = data
                    this.loading--
                })
        },
        handlerDeliveryData() {
            if (this.view_delivery_data == false) {
                this.view_delivery_data = true
            } else {
                this.view_delivery_data = false
            }
        },
        getStates() {
            this.loading++
            axios.get(`/list-department`)
                .then(({ data }) => {
                    this.city_id = ''
                    this.states = data.data
                    this.loading--
                })
        },
        getCities() {
            this.loading++
            axios.get(`list-city/${this.state_id}`)
                .then(({ data }) => {
                    this.cities = data.data
                    this.loading--
                })
        },
        addDeliveryData() {
            if (this.add_delivery_data == false) {
                this.add_delivery_data = true
                this.edit_delivery_data = false
                this.$refs.addDataForm.scrollIntoView({ behavior: 'smooth' });
            } else {
                this.edit_delivery_data = false
                this.$refs.addDataForm.scrollIntoView({ behavior: 'smooth' });
            }

            this.email = ''
            this.mobile_number = ''
            this.state = null
            this.state_id = ''
            this.state_name = ''
            this.city = null
            this.city_id = ''
            this.city_name = ''
            this.address = ''
            this.delivery_instructions = ''
            this.is_default_option = false
        },
        getRedemptionPersonalData(client_id) {
            axios.get(`/personal-data/${client_id}`)
                .then(response => {
                    this.personal_data = response.data.personal_data;
                    this.selected_delivery_data = response.data.personal_data_default;
                    this.personal_data_default = response.data.personal_data_default;
                    this.user_data = response.data.user_data;
                })
                .catch(e => {
                    //
                })
        },
        formatMobileNumber(mobile_number) {
            let formatted_mobile_number;
            formatted_mobile_number = mobile_number.slice(0, 3) + ' ' + mobile_number.slice(3, 6) + ' ' + mobile_number.slice(6);
            return formatted_mobile_number;
        },
        storeDeliveryData() {
            if (this.personal_data && this.personal_data.length == 0) {
                this.is_default_option = true
            }

            let dataSend = {
                'client_id': this.client_id,
                'label_personal_data': this.label_personal_data,
                'email': this.email,
                'mobile_number': this.mobile_number,
                'state_id_nc': this.state_id,
                'state_name_nc': this.state_name,
                'city_id_nc': this.city_id,
                'city_name_nc': this.city_name,
                'address': this.address,
                'delivery_instructions': this.delivery_instructions,
                'is_default_option': this.is_default_option,
            }

            let url = ''
            axios.post('/personal-data', dataSend).then(
                (response) => {
                    this.getRedemptionPersonalData(this.client_id)
                    this.personal_data_default = response.data.personal_data_default;
                    this.add_delivery_data = false
                    this.edit_delivery_data = false

                    this.successfully_created_message = true
                    this.successfully_updated_message = false
                    this.successfully_deleted_message = false

                    this.errors_personal_data = null
                }).catch(
                (error) => {
                    if (error && error.response && error.response.data && error.response.data.errors) {
                        this.errors_personal_data = error.response.data.errors
                    }
                })
        },
        editDeliveryData(item, index) {
            this.$refs.addDataForm.scrollIntoView({ behavior: 'smooth' });
            this.personal_data_to_edit = item

            this.add_delivery_data = true
            this.edit_delivery_data = true

            this.email = item.email
            this.mobile_number = item.mobile_number
            this.state = {
                id_country: 1,
                id_departments: item.state_id_nc,
                name: item.state_name_nc
            }
            // this.city: Se define en el watch de state
            this.address = item.address
            this.delivery_instructions = item.delivery_instructions

            if (this.personal_data_default.id == item.id) {
                this.is_default_option = true
            } else {
                this.is_default_option = false
            }
        },
        updateDeliveryData() {
            let dataSend = {
                'id': this.personal_data_to_edit.id,
                'client_id': this.client_id,
                'label_personal_data': this.label_personal_data,
                'email': this.email,
                'mobile_number': this.mobile_number,
                'state_id_nc': this.state_id,
                'state_name_nc': this.state_name,
                'city_id_nc': this.city_id,
                'city_name_nc': this.city_name,
                'address': this.address,
                'delivery_instructions': this.delivery_instructions,
                'is_default_option': this.is_default_option,
            }

            let url = ''
            axios.put(`/personal-data-update/${this.personal_data_to_edit.id}`, dataSend).then(
                (response) => {
                    this.getRedemptionPersonalData(this.client_id)
                    this.personal_data_default = response.data.personal_data_default;
                    this.add_delivery_data = false
                    this.edit_delivery_data = false

                    this.successfully_created_message = false
                    this.successfully_updated_message = true
                    this.successfully_deleted_message = false

                    this.errors_personal_data = null
                }).catch(
                (error) => {
                    if (error && error.response && error.response.data && error.response.data.errors) {
                        this.errors_personal_data = error.response.data.errors
                    }
                })
        },
        deleteDeliveryData(item, index) {

            axios.delete(`/personal-data-delete/${item.id}`).then(
                (response) => {
                    this.getRedemptionPersonalData(this.client_id)
                    this.personal_data_default = response.data.personal_data_default;
                    this.add_delivery_data = false
                    this.edit_delivery_data = false

                    this.successfully_created_message = false
                    this.successfully_updated_message = false
                    this.successfully_deleted_message = true

                    this.errors_personal_data = null
                }).catch(
                (error) => {
                    if (error && error.response && error.response.data && error.response.data.errors) {
                        this.errors_personal_data = error.response.data.errors
                    }
                })
        },
        changeDeliveryData(id) {
            this.$refs.addDataForm.scrollIntoView({ behavior: 'smooth' });
            let new_selection_delivery_data;
            this.personal_data.forEach(function (element) {
                if (element.id !== id) {
                    element.is_default_option = 0
                } else {
                    element.is_default_option = 1
                    new_selection_delivery_data = element
                }
            }, new_selection_delivery_data);

            this.selected_delivery_data = new_selection_delivery_data
            this.add_delivery_data = false
            this.edit_delivery_data = false

            this.successfully_created_message = false
            this.successfully_updated_message = false
            this.successfully_deleted_message = false
        },
        setCurrentMonth() {
            const currentMonthIndex = new Date().getMonth();
            const lastFourMonths = [];
            for (let i = currentMonthIndex; i > currentMonthIndex - 4; i--) {
                const adjustedIndex = (i < 0) ? i + 12 : i;
                lastFourMonths.unshift(this.months[adjustedIndex]);
            }
            this.pastMonths = lastFourMonths;
        },
        showRedemptionDetail(redemption) {
            if (this.showModalRedemption = true) {
                this.redemption_details = redemption
                this.show_redemption_details = true;
            }

        },
        closeRedemptionDetailModal() {
            this.redemption_details = null
            this.showModalRedemption = false;
            var victoriatour = document.getElementById('victoriatour');
            if (victoriatour) {
                victoriatour.style.display = 'flex';
            } else {
                console.error('Elemento victoriatour no encontrado en el DOM');
            }
        },
        shouldShowVerMas(StatusId) {
            const visibleStatusIds = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 13];
            return visibleStatusIds.includes(StatusId);
        },
        shouldShowDetails(StatusId) {
            return StatusId !== 1 && StatusId !== 12;
        },
        formatName(name) {
            let nameParts = name.split(' ').map(part => {
                return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
            });

            return nameParts.join(' ');
        },
        truncateText(text, maxLength) {
            if (!text) return 'Sin Dirección'
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
        },
        getUserPoints(){
            this.loading++
            axios.get(`/get-user-points`)
                .then(({data}) => {
                    this.userPoints = data.points
                    this.loading--
                })
        },
    },
}
</script>
